import angular from "angular";
import angularMoment from "angular-moment";

let mod = angular
    .module('trainsService', [angularMoment])
    .service('trainsService', ['$http', '$q', 'moment', controller]);

function controller($http, $q, moment) {

    let requests = [];

    this.createRequest = function (depStationCode, arrStationCode, depDate, showWithoutPlaces) {
        requests.push({
            depStationCode: depStationCode,
            arrStationCode: arrStationCode,
            depDate: depDate,
            showWithoutPlaces: showWithoutPlaces,
            defer: $q.defer(),
            canceler: $q.defer()
        });
        return requests.length - 1;
    };

    this.cancelRequest = function (requestInd) {
        if (requests[requestInd].canceler) {
            requests[requestInd].canceler.resolve();
        }
    };

    this.doRequest = function (requestInd) {
        let req = requests[requestInd];

        const params = new window.URLSearchParams(window.location.search);

        $http
            .post('/railways-api/search-trains', {
                DepartureStationCode: req.depStationCode,
                ArrivalStationCode: req.arrStationCode,
                DepartureDate: req.depDate,
                ShowWithoutPlaces: !!params.get('showWithoutPlaces') || false
            }, {
                timeout: req.canceler.promise
            })
            .then(
                function (response) {
                    let notAllTrains = response.data.res.ForwardDirection.NotAllTrains;
                    let trainsCollections = response.data.res.ForwardDirection.Trains[0].TrainsCollection;
                    let trainTypes = response.data.trainTypes;
                    let trainOwners = response.data.trainOwners;
                    let result = [];
                    trainsCollections.forEach(function (train) {
                        let resItem = parseTrain(train);
                        resItem.typeSlug = trainTypes[train.Number];
                        resItem.owner = trainOwners[train.Number];
                        result.push(resItem);
                    });
                    req.defer.resolve(result);
                },
                function (error) {
                    if (error.status != -1) {
                        req.defer.reject(error);
                    }
                }
            );
        return req.defer.promise;
    };

    function getTrainMaxCost(cars) {
        let maxCost = 0;
        cars.forEach(function (car) {
            car.Tariffs.forEach(function (tariff) {
                if (maxCost == 0 || tariff.TariffValue > maxCost) {
                    maxCost = tariff.TariffValue;
                }
            });
        });
        return maxCost;
    }

    function parseTrain(train) {
        let cars = parseCars(train.Cars);
        let minCost = getTrainMinCost(cars);
        let maxCost = getTrainMaxCost(train.Cars);
        return {
            number: train.Number,
            number2: train.Number2,
            type: train.Type,
            startStation: train.Route[0],
            endStation: train.Route[1],
            depDate: moment(train.DepartureDateTime),
            arrDate: moment(train.ArrivalDateTime),
            timeInWay: getTimeInWay(train.TimeInWay),
            depStop: train.DepartureStop,
            arrStop: train.ArrivalStop,
            elRegPossible: train.ElRegPossible,
            isWithoutPassengersInfo: train.IsWithoutPassengerInfo,
            detail: {
                isTransit: train.TrainDetail.IsTransit,
                isWithoutElReg: train.TrainDetail.IsWithoutElReg,
                isObligativeElReg: train.TrainDetail.IsObligativeElReg,
                isInternetTransit: train.TrainDetail.IsInternetTransit,
                isInterstate: train.TrainDetail.IsInterstate
            },
            cars: cars,
            minCost: minCost,
            maxCost: maxCost,
        };
    }

    function getTrainMinCost(cars) {
        let minCost = 0;
        cars.forEach(function (car) {
            if (minCost == 0 || car.minCost < minCost) {
                minCost = car.minCost;
            }
        });
        return minCost;
    }

    function getTimeInWay(timeInWay) {
        let arr = timeInWay.split(':');
        let hoursArr = arr[0].split('.');
        let days = 0;
        let hours = 0;
        let minutes = +arr[1];

        if (hoursArr.length == 2) {
            days = +hoursArr[0];
            hours = +hoursArr[1];
        } else {
            hours = +hoursArr[0];
        }

        return {
            hours: days * 24 + hours,
            minutes: minutes
        };
    }

    function parseCars(cars) {
        let result = [];
        cars.forEach(function (car) {
            let typeLabel = getCarTypeLabel(car.Type);
            let typeSlug = getCarTypeSlug(car.Type);
            result.push({
                typeNumber: car.Type,
                typeLabel: typeLabel,
                typeSlug: typeSlug,
                freeSeats: car.FreeSeats,
                seats: {
                    freeComp: car.Seats ? car.Seats.FreeComp : 0,
                    seatsDn: car.Seats ? car.Seats.SeatsDn : 0,
                    seatsUp: car.Seats ? car.Seats.SeatsUp : 0,
                    seatsLateralDn: car.Seats ? car.Seats.SeatsLateralDn : 0,
                    seatsLateralUp: car.Seats ? car.Seats.SeatsLateralUp : 0,
                    seatsUndef: car.Seats ? car.Seats.SeatsUndef : 0,
                },
                minCost: getCarMinCost(car.Tariffs)
            });
        });
        return result;
    }

    function getCarTypeSlug(carTypeNumber) {
        switch (carTypeNumber) {
            case (1):
                return 'obwiy';
            case (2):
                return 'sitting';
            case (3):
                return 'placcart';
            case (4):
                return 'kupe';
            case (5):
                return 'myagkiy';
            case (6):
                return 'lux';
        }
        return null;
    }

    function getCarTypeLabel(carTypeNumber) {
        switch (carTypeNumber) {
            case (1):
                return 'Общий';
            case (2):
                return 'Сидячий';
            case (3):
                return 'Плацкарт';
            case (4):
                return 'Купе';
            case (5):
                return 'Мягкий';
            case (6):
                return 'Люкс';
        }
        return null;
    }

    function getCarMinCost(tariffs) {
        let minCost = 0;
        tariffs.forEach(function (tariff) {
            if (minCost == 0 || tariff.TariffValue < minCost) {
                minCost = tariff.TariffValue;
            }
        });
        return minCost;
    }

}

export default mod.name;



// WEBPACK FOOTER //
// ./resources/assets/modules/booking-module/trainsService/trainsService.js